<div class="card" style="width: 39%; float: left; margin-left: 1rem;">
  <div class="card-header bg-primary text-white">
    <h3 class="mb-0 text-center">Itinerary Input Form</h3>
  </div>
  <div class="card-body">
    <form [formGroup]="itineraryForm" (ngSubmit)="onSubmit()">

      <div class="row mb-3">
        <div class="col-md-6">
          <label class="form-label">Days</label>
          <input type="number" formControlName="days" min="1" class="form-control">
        </div>
        <div class="col-md-6">
          <label class="form-label">Nights</label>
          <input type="number" formControlName="nights" min="1" class="form-control">
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Destination(s)</label>
        <select formControlName="destination" class="form-select" multiple>
          <option *ngFor="let d of destinations" [value]="d">{{d}}</option>
        </select>
      </div>

      <div class="mb-3">
        <label class="form-label">Traveler Interests</label>
        <select formControlName="interests" class="form-select" multiple>
          <option *ngFor="let i of interests" [value]="i">{{i}}</option>
        </select>
      </div>

      <div class="row mb-3">
        <div class="col-md-4">
          <label class="form-label">Food Preferences</label>
          <select formControlName="foodPreferences" class="form-select">
            <option *ngFor="let t of foodPreferences" [value]="t">{{t}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Accessibility Toggle(s)</label>
          <select formControlName="accessibilityToggle" class="form-select">
            <option *ngFor="let e of accessibilityToggle" [value]="e">{{e}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Pace</label>
          <select formControlName="pace" class="form-select">
            <option *ngFor="let e of paceList" [value]="e">{{e}}</option>
          </select>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <label class="form-label">Season Preferences</label>
          <select formControlName="seasonPreferences" class="form-select" multiple>
            <option *ngFor="let s of seasons" [value]="s">{{s}}</option>
          </select>
        </div>
      </div>

      <div class="text-center">
        <button type="submit" class="btn btn-primary btn-lg mt-3">Submit</button>
      </div>

    </form>
  </div>
</div>
<div class="card" style=" width: 59%; float: left; margin-left: 1rem; overflow-y: scroll; max-height: 750px;">
  <app-mapview></app-mapview>
</div>